import {
  SetIsCancellationFee,
  Next,
  SetCancellationFeeSize,
  SetShouldCloseTime,
  SetCancelOnBehalfOf,
  SetShouldSendCustomerMessages,
  SetShouldSendPartnerMessages,
} from "./actions";
import {SetCancelReason} from "./actions/setCancelReason.action";

export type CancelBookingAdminActions =
  | Next
  | SetIsCancellationFee
  | SetCancellationFeeSize
  | SetShouldCloseTime
  | SetCancelOnBehalfOf
  | SetShouldSendCustomerMessages
  | SetShouldSendPartnerMessages
  | SetCancelReason;

export const cancelBookingAdminActions = [
  Next,
  SetIsCancellationFee,
  SetCancellationFeeSize,
  SetShouldCloseTime,
  SetCancelOnBehalfOf,
  SetShouldSendCustomerMessages,
  SetShouldSendPartnerMessages,
  SetCancelReason,
] as const;

export type cancelBookingAdminStateActions = (typeof cancelBookingAdminActions)[number];

export interface IGetData {
  cancellationFeeSize: FeeSize;
  shouldCloseTime: boolean;
  cancelOnBehalfOf: OnBehalfOf;
  shouldSendCustomerMessages: boolean;
  shouldSendPartnerMessages: boolean;
  cancelReason: string;
}

export type OnBehalfOf = "Customer" | "Partner";
export type FeeSize = 0 | 50 | 100;
